var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogobg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 447,
    viewBox: "0 0 396 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.304 105.188C254.137 68.854 222.609 15.5701 198 15.221C182.682 15.006 166.253 36.9125 154.084 73.2448C150.089 85.336 146.786 97.6449 144.19 110.112C143.153 115.04 142.183 120.086 141.278 125.249C138.922 138.748 137.073 152.972 135.75 167.719C135.18 173.959 134.719 180.305 134.342 186.719C133.649 198.735 133.297 211.022 133.297 223.471C133.297 235.92 133.649 248.207 134.342 260.223C128.978 256.688 123.729 253.114 118.597 249.5C118.246 240.928 118.074 232.233 118.074 223.471C118.074 214.709 118.246 206.013 118.597 197.44C118.844 190.971 119.193 184.569 119.644 178.232C120.965 158.781 123.331 139.415 126.732 120.217C127.645 115.098 128.634 110.088 129.7 105.185C132.342 92.7548 135.664 80.4793 139.652 68.4136C154.427 24.2986 175.149 0 198 0C220.851 0 241.564 24.303 256.339 68.4136C260.326 80.4803 263.651 92.7556 266.3 105.185",
    fill: "url(#paint0_linear_181_1937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.696 341.765C141.863 378.099 173.391 431.384 197.996 431.729C213.314 431.944 229.743 410.037 241.912 373.703C245.907 361.612 249.21 349.303 251.806 336.837C252.843 331.909 253.813 326.864 254.718 321.701C257.074 308.2 258.923 293.978 260.246 279.231C260.816 272.99 261.277 266.644 261.654 260.231C262.347 248.215 262.699 235.928 262.699 223.479C262.699 211.03 262.347 198.743 261.654 186.727C267.018 190.262 272.266 193.835 277.399 197.448C277.75 206.02 277.922 214.716 277.922 223.479C277.922 232.241 277.75 240.936 277.399 249.508C277.152 255.977 276.802 262.38 276.352 268.716C275.03 288.168 272.664 307.535 269.264 326.732C268.351 331.851 267.362 336.859 266.296 341.756C263.654 354.186 260.332 366.462 256.344 378.527C241.569 422.647 220.848 446.945 198 446.945C175.153 446.945 154.436 422.642 139.661 378.53C135.674 366.463 132.349 354.188 129.7 341.759",
    fill: "url(#paint1_linear_181_1937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.285 341.765C303.836 349.393 365.745 348.733 378.346 327.597C386.195 314.432 375.435 289.255 350.052 260.551C341.58 251.046 332.572 242.031 323.073 233.55C319.323 230.187 315.439 226.824 311.42 223.461C300.903 214.675 289.513 205.957 277.404 197.437C272.284 193.823 267.034 190.25 261.654 186.719C251.595 180.111 241.16 173.683 230.349 167.437C219.565 161.21 208.751 155.374 197.998 149.967C203.746 147.09 209.465 144.332 215.156 141.692C222.756 145.674 230.358 149.861 237.96 154.255C245.562 158.648 252.989 163.137 260.242 167.721C265.719 171.171 271.089 174.675 276.353 178.232C292.537 189.104 308.126 200.838 323.05 213.385C327.026 216.735 330.87 220.097 334.583 223.471C344.027 231.973 352.996 240.989 361.451 250.475C392.269 285.329 402.952 315.423 391.527 335.213C380.101 355.003 348.7 360.792 303.108 351.529C290.665 348.948 278.373 345.69 266.285 341.771",
    fill: "url(#paint2_linear_181_1937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.714 105.178C92.1641 97.5488 30.2548 98.2101 17.6541 119.346C9.80497 132.511 20.5646 157.686 45.9472 186.392C54.4198 195.898 63.4276 204.913 72.9265 213.393C76.6765 216.755 80.561 220.118 84.5801 223.482C95.0966 232.267 106.487 240.985 118.595 249.504C123.715 253.119 128.965 256.692 134.345 260.223C144.404 266.833 154.839 273.261 165.65 279.506C176.435 285.732 187.249 291.569 198.001 296.975C192.254 299.853 186.535 302.611 180.843 305.251C173.243 301.269 165.642 297.082 158.04 292.689C150.438 288.295 143.01 283.806 135.758 279.22C130.28 275.771 124.91 272.267 119.647 268.71C103.462 257.84 87.8743 246.107 72.95 233.563C68.9741 230.214 65.1298 226.851 61.4171 223.477C51.973 214.975 43.0033 205.96 34.5483 196.474C3.73069 161.62 -6.95232 131.518 4.47303 111.734C15.8984 91.9503 47.2993 86.1573 92.8917 95.419C105.334 98.0009 117.627 101.259 129.714 105.178Z",
    fill: "url(#paint3_linear_181_1937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.59 223.49C359.973 194.786 390.356 140.841 378.352 119.355C370.874 105.975 343.691 102.711 306.142 110.335C293.674 112.921 281.362 116.216 269.268 120.204C264.481 121.769 259.627 123.451 254.704 125.25C241.837 129.963 228.592 135.47 215.16 141.698C209.469 144.324 203.75 147.084 198.002 149.979C187.249 155.386 176.435 161.221 165.651 167.449C154.866 173.676 144.404 180.116 134.345 186.731C134.728 180.315 135.199 173.981 135.758 167.73C143.006 163.14 150.433 158.652 158.04 154.263C165.629 149.882 173.23 145.694 180.844 141.701C186.57 138.68 192.29 135.784 198.002 133.011C215.508 124.429 233.463 116.794 251.789 110.141C256.678 108.373 261.512 106.725 266.291 105.195C278.378 101.269 290.671 98.0081 303.114 95.4279C348.707 86.1663 380.11 91.9622 391.537 111.752C402.964 131.542 392.274 161.629 361.458 196.483C353 205.967 344.031 214.983 334.59 223.49Z",
    fill: "url(#paint4_linear_181_1937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4097 223.462C36.0271 252.168 5.64395 306.113 17.6481 327.597C25.1261 340.977 52.3086 344.241 89.8575 336.617C102.326 334.03 114.638 330.735 126.732 326.749C131.519 325.177 136.373 323.495 141.296 321.701C154.163 316.988 167.408 311.48 180.84 305.253C186.531 302.627 192.25 299.867 197.998 296.972C208.751 291.567 219.565 285.729 230.349 279.504C241.134 273.278 251.596 266.837 261.655 260.22C261.272 266.638 260.801 272.972 260.242 279.221C252.994 283.812 245.567 288.302 237.96 292.689C230.371 297.069 222.77 301.257 215.156 305.251C209.43 308.271 203.71 311.168 197.998 313.942C180.492 322.524 162.537 330.158 144.211 336.811C139.322 338.579 134.488 340.227 129.708 341.756C117.622 345.684 105.33 348.944 92.8858 351.523C47.2934 360.786 15.8895 354.99 4.46268 335.199C-6.96414 315.407 3.72622 285.323 34.5424 250.47C42.999 240.983 51.9671 231.965 61.4068 223.456",
    fill: "url(#paint5_linear_181_1937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.733 75.8627C258.977 75.8627 271.334 63.5054 271.334 48.2619C271.334 33.0184 258.977 20.6611 243.733 20.6611C228.49 20.6611 216.132 33.0184 216.132 48.2619C216.132 63.5054 228.49 75.8627 243.733 75.8627Z",
    fill: "url(#paint6_linear_181_1937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.362 404.701C157.861 404.701 165.562 397 165.562 387.5C165.562 378 157.861 370.299 148.362 370.299C138.862 370.299 131.161 378 131.161 387.5C131.161 397 138.862 404.701 148.362 404.701Z",
    fill: "url(#paint7_linear_181_1937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5849 262.315C104.028 262.315 113.304 253.039 113.304 241.596C113.304 230.153 104.028 220.876 92.5849 220.876C81.1419 220.876 71.8655 230.153 71.8655 241.596C71.8655 253.039 81.1419 262.315 92.5849 262.315Z",
    fill: "url(#paint8_linear_181_1937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 302.623C385.672 302.623 395.993 292.302 395.993 279.57C395.993 266.838 385.672 256.518 372.94 256.518C360.209 256.518 349.888 266.838 349.888 279.57C349.888 292.302 360.209 302.623 372.94 302.623Z",
    fill: "url(#paint9_linear_181_1937)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_1937",
    x1: 192.189,
    y1: 260.223,
    x2: 192.189,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_1937",
    x1: 203.809,
    y1: 446.945,
    x2: 203.809,
    y2: 186.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181_1937",
    x1: 354.213,
    y1: 361.831,
    x2: 208.291,
    y2: 145.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_181_1937",
    x1: 172.46,
    y1: 311.675,
    x2: 26.5437,
    y2: 95.4022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_181_1937",
    x1: 219.906,
    y1: 236.065,
    x2: 246.788,
    y2: 54.0156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_181_1937",
    x1: 77.1881,
    y1: 382.302,
    x2: 104.072,
    y2: 200.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_181_1937",
    x1: 257.534,
    y1: 72.1642,
    x2: 229.933,
    y2: 24.3596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_181_1937",
    x1: 156.962,
    y1: 402.396,
    x2: 139.761,
    y2: 372.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_181_1937",
    x1: 102.945,
    y1: 259.539,
    x2: 82.2252,
    y2: 223.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9870FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_181_1937",
    x1: 384.466,
    y1: 299.533,
    x2: 361.414,
    y2: 259.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC8FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogobg);
export default __webpack_public_path__ + "static/media/logobg.3bac9a803952ad01ab955ca8139c7d73.svg";
export { ForwardRef as ReactComponent };